import React from 'react';
import { useI18n } from '@/i18n/I18nProvider';
import { Link } from 'react-router-dom';

const LogoGroup = () => {
  const { locale } = useI18n();
  return (
    <div className="header-logo logos">
      <div className="logo-item">
        <Link to="/" className="logo block">
          <img src={locale === 'ar' ? '/moe-logo-ar.svg' : '/moe-logo-en.svg'} alt="logo" width={223} height={80} />
          <span className="sr-only">Logo</span>
        </Link>
      </div>
    </div>
  );
};

export default LogoGroup;
